export default __webpack_public_path__ + "static/media/sapphire_logo_vertical@2x.aed9d49e.png";